module.exports = __webpack_public_path__ + "static/media/snorlaxClipart.5e4ae7d2.png";